var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"body-1",attrs:{"to":{ name: 'courses', params: { filterSearch: _vm.course.id } }}},[_vm._v("K"+_vm._s(_vm.course.id)+" "+_vm._s(_vm.courseTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }